export default __webpack_public_path__ + "static/cavemanBones-2c1a1252ffed44b766df44962ce9a8bd.svg";